(function () {
  const root = document.querySelector('[data-social-proof-popup]');
  if (!root) return;

  let products = [];
  try {
    const jsonEl =
      root.querySelector('[type="application/json"][data-social-proof-products]') ||
      document.querySelector('[type="application/json"][data-social-proof-products]');
    const raw = jsonEl?.textContent?.trim();
    products = raw ? JSON.parse(raw) : [];
  } catch (e) {
    return;
  }

  if (!products.length) return;

  const names = [
    'Rahul',
    'Priya',
    'Amit',
    'Neha',
    'Vikram',
    'Ananya',
    'Arjun',
    'Kavya',
    'Rohan',
    'Isha',
    'Siddharth',
    'Meera',
    'Karan',
    'Divya',
    'Aditya',
    'Sneha',
    'Manish',
    'Pooja',
    'Nikhil',
    'Shreya',
  ];

  const cities = [
    'Delhi',
    'Mumbai',
    'Bengaluru',
    'Hyderabad',
    'Chennai',
    'Kolkata',
    'Pune',
    'Ahmedabad',
    'Jaipur',
    'Lucknow',
    'Chandigarh',
    'Indore',
    'Kochi',
    'Gurgaon',
    'Noida',
  ];

  const minMs = Math.max(5000, parseInt(root.dataset.intervalMin, 10) || 30000);
  const maxMs = Math.max(minMs, parseInt(root.dataset.intervalMax, 10) || 60000);
  const visibleMs = Math.max(3000, parseInt(root.dataset.visibleMs, 10) || 6000);

  const textEl = root.querySelector('[data-social-proof-text]');
  const imgEl = root.querySelector('[data-social-proof-img]');
  const closeBtn = root.querySelector('[data-social-proof-close]');

  let hideTimer = null;
  let scheduleTimer = null;

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function randomIntervalMs() {
    return minMs + Math.floor(Math.random() * (maxMs - minMs + 1));
  }

  function hidePopup() {
    root.classList.remove('is-visible');
  }

  function show() {
    const product = pick(products);
    if (!product || !product.title) return;

    const name = pick(names);
    const city = pick(cities);
    const line = `${name} from ${city} just purchased`;

    if (textEl) {
      textEl.textContent = '';
      const nameSpan = document.createElement('span');
      nameSpan.className = 'social-proof-popup__name';
      nameSpan.textContent = line;
      const titleA = document.createElement('a');
      titleA.className = 'social-proof-popup__product';
      titleA.href = product.url || '#';
      titleA.textContent = product.title;
      textEl.appendChild(nameSpan);
      textEl.appendChild(titleA);
    }

    if (imgEl) {
      if (product.image) {
        imgEl.src = product.image;
        imgEl.alt = '';
        imgEl.hidden = false;
      } else {
        imgEl.removeAttribute('src');
        imgEl.hidden = true;
      }
    }

    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-visible'));
  }

  function queueNext() {
    if (scheduleTimer) clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(() => {
      scheduleTimer = null;
      show();
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        hideTimer = null;
        hidePopup();
        queueNext();
      }, visibleMs);
    }, randomIntervalMs());
  }

  closeBtn?.addEventListener('click', () => {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    if (scheduleTimer) {
      clearTimeout(scheduleTimer);
      scheduleTimer = null;
    }
    hidePopup();
    queueNext();
  });

  queueNext();
})();
